// Subscription tier feature matrix (mirrors backend PLAN_FEATURES).
export const PLAN_FEATURES = {
  starter: { label: "Starter", tactical_board: false, medical: false, director: false, director_budget: false, players_to_sign: false, squad: false, multi_team: false, max_users: 3 },
  pro: { label: "Pro", tactical_board: true, medical: false, director: true, director_budget: false, players_to_sign: true, squad: true, multi_team: false, max_users: 5 },
  club: { label: "Club", tactical_board: true, medical: true, director: true, director_budget: true, players_to_sign: true, squad: true, multi_team: true, max_users: null },
};

export function planOf(user) {
  const p = user && typeof user === "object" && user.org ? user.org.plan : null;
  return PLAN_FEATURES[p] ? p : "starter";
}

export function planAllows(user, feature) {
  return !!PLAN_FEATURES[planOf(user)][feature];
}
